const langArr = {
  welcome: {
    en: 'Hi!',
    en2: 'Iʼm Nastia',
    ua: 'Привіт!',
    ua2: 'Я Настя',
  },
  language: {
    en: 'I speak',
    ua: 'Можу спілкуватися',
  },
  like: {
    en: 'I can:',
    ua: 'Я можу:',
  },
  likeList: {
    en: ['write', 'draw', 'code', 'make photos'],
    ua: ['писати', 'малювати', 'кодити', 'фотографувати'],
  },
  noPage: {
    en: 'Page not found:',
    ua: 'Сторінка не знайдена',
  },
  goHome: {
    en: 'To Home page',
    ua: 'На головну сторінку',
  },
  footer: {
    en: 'contact me in a convenient way',
    ua: 'звʼяжися зі мною зручним способом',
  },
  headerTitle: {
    en: 'Look what Nastia can do',
    ua: 'Дивись, як Настя вміє',
  },
  codeTeh: {
    en: 'know it',
    ua: 'знаю це',
  },
  codePortfolio: {
    en: 'my works',
    ua: 'мої роботи',
  },
  click: {
    en: 'click on the item',
    ua: 'тицяй на назву',
  },
  oops: {
    en: 'oops, something went wrong',
    ua: 'трясця, щось пішло не так',
  },
  writePageTitle: {
    en: 'Life situations have been digested by me and presented in short essays',
    ua: 'Життєві ситуації перетравлені мною та викладені у коротких есе',
  },
  drawPageTitle: {
    en: `Drawing is a magical process because it teaches me to see the smallest details. That's how I learned that the world is not divided into black and white, and a flaw, at first glance, is actually a beautiful feature.`,
    ua: `Малювання – це чарівний процес, бо він вчить мене бачити найдрібніші деталі. Так я дізналась, що світ не ділиться на чорне і біле, а недолік, на перший погляд, насправді є прекрасною рисою.`,
  },
  codePageTitle: {
    en: `I like to create. And development and programming is one of the best ways to create something useful today.`,
    ua: 'Мені подобається створювати. А розробка та програмування — один з кращих способів створити щось корисне на теперішній час.',
  },
  photoPageTitle: {
    en: `It is not for nothing that the small window on the camera is called the viewfinder. I like to look in the environment for views that I want to immortalize. Here are some of them.`,
    ua: 'Не даремно маленьке віконце на фотоапараті називається видошукач. Мені подобається шукати в навколишньому середовищі кадри, які хочеться увічнити. Тут деякі з них.',
  },
  timeLineTitle: {
    en: `My short biography`,
    ua: `Моя коротка біографія`,
  },
  feedbackTitle: {
    en: `Feedbacks`,
    ua: `Відгуки`,
  },
  feedbackBtn: {
    en: `Leave your feedback`,
    ua: `Залишити свій відгук`,
  },
  summary: {
    en: ``,
    ua: ``,
  }
};

export default langArr;
